import {Feature} from '@catcore/services/feature/feature';
import {GenericLinkedResource, GenericResourceInfo, GenericSelfInfo} from '@catcore/types/base';
import {ProjectFeature} from '@catmodules/models/project-feature/types';
import {SelectItem} from 'primeng/primeng';
import {ROLE} from "@catcore/services/user.service";

export interface Project {
  id: number;
  number: number;
  name: string;
  valid: boolean;
  user_data_files?: any[];
  all_units?: any[];
  lopa?: string;
  _links: {
    self: {
      href: string;
    };
    all_services?: GenericLinkedResource[];
  };
}

export interface GuiZone {
  id: number;
  name: string;
  type: string;
  short_name: string;
  sort_index: number;
  _links: GenericSelfInfo;
}

export interface GuiZoneWithIcon extends GuiZone {
  icon_name: string;
  icon_name_in_file_system: string;
  icon: string;
  lopa_pos: string;
  image_x: number;
  image_y: number;
}

export interface GuiZoneCreateInfo {
  name: string;
  shortName: string;
  zonePa: string;
  type: string;
  sortIndex: number;
  group_type?: string;
  parent?: GenericResourceInfo;
  project: GenericResourceInfo;
}

export interface ProjectGgwDevice {
  id: number;
  name: string;
  description: string;
  name_used_in_gui: string;
  icon_roles: string[];
  icon_x: string[];
  icon_y: string[];
  _links: GenericSelfInfo;
}

/**
 * Helper model to create a selection reference between two ports.
 * It is used to address requirements by the WebAPI v1
 */
export interface CustomSelectionPair {
  reference: string;
  selected: string;
}

export interface ProjectFeatureCreateInfo {
  featureName: string;
  project: Project;
  guiZone: GuiZone;
  feature: Feature;
  selections: CustomSelectionPair[];
}

export interface ProjectFeatureCreateResult {
  status: FeatureCreateResultType;
  constraints: ProjectFeatureCreateConstraint[];
  features: ProjectFeature[];
  selections: ProjectFeatureCreateSelection[];
}

export enum FeatureCreateResultType {
  success, unfullfiledConstraints, missingSelections, failed,
}

export interface ProjectFeatureCreateConstraint {
  code: string;
  message: string;
  property_path: string;
}

export interface ProjectFeatureCreateSelection {
  name: string;
  options: SelectItem[];
  reference: string;
}

export interface CatUser {
  name: string;
  roles: ROLE[];
  hasRole: (role: ROLE) => boolean;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/types/api-v2/index.ts